module.exports = __webpack_public_path__ + "assets/RussoOne-Regular.5fdbab54aeddeee59bdb891c00b5406926cfbcf0d4a922d8bd72ad16362e1373.woff2";